module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABE0lEQVQ4T42Ta1FCURSFPxKICbSBmEBtIAkgAiQAE2gETaAN1ARKA0wANGA+5uw7m+O5ypm5P+5+rLX2a0D7DYEbYFTc38AnsK3DB5XBxEdg2gP8DMwzUAaQ7RW47EkO8xoYA6oiAGT+OiE5g1yrJACUNineHSDLVaVkVQjOiv3FUgWQfZOCTRb9KYEaPGuoPBfgvtSeCa3vroBoN/k9TSVixwIsgUWjcQGiq5Ws/eEvgJBtYC4ncx0AWiVEssy+KCcafVRC3US7fVvJjnI+qukcmujLY3Rd/eqFcjqS+fm6MfqjUZaLf7Yw3D9lIt0i6XCV304AMdm+Ha1yIKukr+Mh253orrK+xgxkI/M528Bf57wH1FA70c9WozUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/del.png
// module id = 6UEO
// module chunks = 1